var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add More"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0799 13.62V13.92H16.3799H21.05L21.0503 13.9201H21.1202C21.7173 13.9201 22.2001 14.4043 22.2 15V15.0001C22.2 15.5971 21.7158 16.08 21.12 16.08H16.38H16.08L16.08 16.38L16.0799 21.12C16.0799 21.7171 15.5957 22.2 14.9999 22.2C14.4029 22.2 13.92 21.7158 13.92 21.12V16.38V16.08H13.62H8.87995C8.28288 16.08 7.8 15.5958 7.8 15.0001C7.8 14.4043 8.28288 13.9201 8.87995 13.9201H8.87996L13.62 13.92L13.92 13.92V13.62V8.87995C13.92 8.28288 14.4042 7.8 14.9999 7.8C15.597 7.8 16.0799 8.2842 16.0799 8.87995V13.62Z",
    fill: "#898989",
    stroke: "white",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusImg2);
export default __webpack_public_path__ + "static/media/plusImg2.23842942bdfa95e707ae0921418d167a.svg";
export { ForwardRef as ReactComponent };